import { CHAT_INTENTS, type ChatIntent } from '@/types/chat';

/** Public navigation hints only: never carry questionnaire answers or free text. */
export function readChatIntent(
  params: URLSearchParams,
): ChatIntent | undefined {
  const values = params.getAll('intent');
  return values.length === 1 && CHAT_INTENTS.includes(values[0] as ChatIntent)
    ? (values[0] as ChatIntent)
    : undefined;
}

export function withChatIntent(path: string, intent?: ChatIntent) {
  return intent
    ? `${path}${path.includes('?') ? '&' : '?'}intent=${intent}`
    : path;
}
